// extracted by css-extract-rspack-plugin
export default {"clearBtn":"clear-btn_T3LaN","container":"container_pi6ir","signaturePad":"signature-pad_Ymb0I","longImage":"longImage_MrzaL"};